import {Icon} from "antd";
import React from "react";
import {exportTextInRef} from "../../common/util";

export type FlightRouteProps = ({
    pairs?: { departure: string, destination: string }[]
} | {
    path: string[]
}) & {
    disableColors?: boolean
}

const FlightRoute = React.forwardRef<any, FlightRouteProps>(function FlightRoute(props, _ref){
    let route: string[] = [];
    if ('pairs' in props) {
        props.pairs?.forEach(pair => {
            if (route.length === 0) {
                route.push(pair.departure);
            }
            route.push(pair.destination);
        });
    } else if ('path' in props) {
        route = props.path;
    }

    const routeText = route.join(' -> ');

    const ref = exportTextInRef(routeText, _ref);

    function getTextColor(index: number) {
        if (props.disableColors) {
            return undefined;
        }
        if (index === 0) {
            return 'green';
        }
        if (index === route.length - 1) {
            return 'red';
        }
        return undefined;
    }

    return (
        <span ref={ref}>
            {route.map((loc, index) => (
                <span key={index}>
                    <span style={{ color: getTextColor(index) }}>{loc}</span>
                    {index < route.length - 1 && <span style={{ marginRight: 6, marginLeft: 6 }}><Icon type="arrow-right" /></span>}
                </span>
            ))}
        </span>
    );
});

FlightRoute.defaultProps = {
    disableColors: false
}

export default FlightRoute;